<style>
#inspectionRegisterModal .modal__footer {
  display: none;
}
#inspectionRegisterModal .modal__content {
  height: calc(100% - 60px) !important;
}
#inspectionRegisterModal .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 780px !important;
}
</style>

<template>
  <Modal
    modalName="inspectionRegisterModal"
    title="REJESTR PRZEGLĄDÓW"
    :buttons=[]
    :register="register"
  >
    <InspectionsTable />
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";
import InspectionsTable from "../../../table/InspectionsTable";

export default {
  components: {
    Modal,
    InspectionsTable
  },
  data: () => ({
    register: true
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/modals/inspections/InspectionsRegister.vue